import RecaptchaComponent from '@components/Recaptcha/RecaptchaComponent.vue';
import CheckboxComponent from '@components/Checkbox/CheckboxComponent.vue';

import {Vue, axios, eventBus} from '@master';

const registerPage = new Vue({
    el: '#register_page',
    title: "Register",
    data () {
        return {
            registering: false,
            business: {
                name: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                postalCode: '',
                country: 'USA',
                phone: '',
                website: '',
            },
            user: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
            },
            referral: '',
            requestDemo: false,
            recaptcha: ''
        }
    },
    methods: {
        openLogin() {
            this.openLoginModal(($event) => window.location.reload())
        },
        async doRegistration() {
            const valid = this.$validator.validate();
            if(!valid) {
                return;
            }
            try {
                this.registering = true;

                const payload = {
                    business: this.business,
                    user: this.user,
                    referral: this.referral,
                    requestDemo: this.requestDemo,
                    captcha: this.recaptcha
                };

                const response = (await axios.post('/register', payload)).data;
                this.swalSuccess("Thank you for registering with Flight Sugar!  Our staff will be contacting you shortly to get you started on our platform.", "Registration Successful!");

                // reset business
                this.business.name = '';
                this.business.address = '';
                this.business.address2 = '';
                this.business.city = '';
                this.business.state = '';
                this.business.postalCode = '';
                this.business.country = 'USA';
                this.business.phone = '';
                this.business.website = '';
                // reset user
                this.user.firstName = '';
                this.user.lastName = '';
                this.user.email = '';
                this.user.phone = '';

                this.referral = '';
                this.requestDemo = '';

                this.registering = false;

                this.$validator.reset();

                this.gaEvent('engagement', 'register', 'Register', { method: 'internal' });
                this.gaPageView('/success', 'Registration Successful');

            } catch(error) {
                this.registering = false;
                if(error.status == 422) {
                    let errors = error.data.errors;
                    for(let field in errors) {
                        this.$validator.errors.add({
                            field: field,
                            msg: errors[field][0],
                            scope: this.$options.scope
                        });
                    }
                } else {
                    this.swalError(error.data.message);
                }
            } finally {
                eventBus.$emit('clearRecaptcha');
            }
        }
    },
    mounted() {
        this.gaPageView(`/register`, 'Register');

        const params = new URLSearchParams(window.location.search);

        if (params.has('data')) {
            const defaults = JSON.parse(atob(params.get('data')).toString('utf-8'));

            this.user.firstName = defaults?.firstName || '';
            this.user.lastName = defaults?.lastName || '';
            this.user.email = defaults?.email || '';

            this.business.name = defaults?.agency || '';
            this.business.phone = defaults?.phone || '';
            this.business.address = defaults?.address_1 || '';
            this.business.address2 = defaults?.address_2 || '';
            this.business.city = defaults?.city || '';
            this.business.state = defaults?.state || '';
            this.business.postalCode = defaults?.zip || '';

            this.referral = defaults?.referral || '';
        }
    },
    components: {
        'recaptcha': RecaptchaComponent,
        'checkbox': CheckboxComponent
    }
});
